import {listFiles} from "@/views/upload/api/listFiles";
import {initMultiUpload} from "@/views/upload/api/initMultiUpload";
import {fileReaderSlice, chunkSize, computedSliceSize, md5File} from "@/views/upload/utils/utils";
import {getMultiUploadUrls} from "@/views/upload/api/getMultiUploadUrls";
import SparkMD5 from "spark-md5";
import CryptoJS from "crypto-js";
import {commitMultiUploadFile} from "@/views/upload/api/commitMultiUploadFile";
import {putFile} from "@/views/upload/api/doUpload";
import {getUploadedPartsInfo} from "@/views/upload/api/getUploadedPartsInfo";
import store from "@/store"

export const uploadCloudOpenFile = async (file, token, onprogress, onerror) => {
    if (onprogress) {
        onprogress({
            progress: 0,
            msg: "正在获取云盘空间"
        })
    }
    const folderResp = await listFiles(token)
    if (folderResp.code !== 0) {
        console.log(folderResp)
        if (onerror) {
            onerror(folderResp)
        }
        if (onprogress) {
            onprogress({
                progress: 100,
                msg: "上传失败"
            })
        }
        return false;
    }
    if (onprogress) {
        onprogress({
            progress: 0,
            msg: "正在读取文件"
        })
    }
    const md5FileResp = await md5File(file)
    if (md5FileResp.code !== 0) {
        console.log(md5FileResp)
        if (onerror) {
            onerror(md5FileResp)
        }
        if (onprogress) {
            onprogress({
                progress: 100,
                msg: "上传失败"
            })
        }
        return false;
    }
    const fileName = file.name
    const fileMd5 = md5FileResp.data.toUpperCase()
    const fileSize = file.size > chunkSize ? file.size : file.size
    const chunks = Math.ceil(file.size / chunkSize)
    const fileChunkList = [];
    const chunksMd5Hex = [];
    let count = 0;

    while (count < chunks) {
        const chunk = file.slice(count, (count + 1) * chunkSize)
        const blobData = await fileReaderSlice(file, count, chunkSize)
        const sliceSize = computedSliceSize(chunk.size)
        const hexMd5 = SparkMD5.ArrayBuffer.hash(blobData).toUpperCase()
        const sliceMd5 = hexMd5
        const base64Md5 = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Hex.parse(hexMd5))
        fileChunkList.push({
            index: 'partNumber_' + (count + 1),
            file: chunk,
            blobData: blobData,
            parentFolderId: folderResp.data.id,
            fileName: fileName,
            fileMd5: fileMd5,
            fileSize: fileSize,
            sliceSize: sliceSize,
            sliceMd5: sliceMd5,
            base64md5: base64Md5
        });
        chunksMd5Hex.push(sliceMd5)
        count++;
    }
    const sliceMd5 = file.size > chunkSize ? SparkMD5.hash(chunksMd5Hex.join('\n')) : fileMd5
    if (onprogress) {
        onprogress({
            progress: 1,
            msg: "正在初始化"
        })
    }
    const multiUploadData = await initMultiUpload(token, folderResp.data.id, fileName, fileMd5, fileSize, chunkSize, sliceMd5)
    if (multiUploadData.code !== "SUCCESS") {
        if (onerror) {
            onerror(md5FileResp)
        }
        if (onprogress) {
            onprogress({
                progress: 100,
                msg: "上传失败"
            })
        }
        console.log(multiUploadData)
    }
    if (multiUploadData.data.fileDataExists === 1) {
        if (onprogress) {
            onprogress({
                progress: 5,
                msg: "正在上传"
            })
        }
        const file = await commitMultiUploadFile(token, multiUploadData.data.uploadFileId)
        if (file.code === "SUCCESS") {
            if (onprogress) {
                onprogress({
                    progress: 100,
                    msg: "上传成功"
                })
            }
            console.log("上传成功")
        } else {
            if (onerror) {
                onerror(file)
            }
            if (onprogress) {
                onprogress({
                    progress: 100,
                    msg: "上传失败"
                })
            }
            console.log(file)
        }
    } else {
        if (onprogress) {
            onprogress({
                progress: 5,
                msg: "正在获取上传地址"
            })
        }
        const uploadUrlBo = await getMultiUploadUrls(token, multiUploadData.data.uploadFileId, fileChunkList)
        if (uploadUrlBo.code !== "SUCCESS") {
            if (onerror) {
                onerror(uploadUrlBo)
            }
            if (onprogress) {
                onprogress({
                    progress: 100,
                    msg: "上传失败"
                })
            }
            console.log(uploadUrlBo)
        }
        let progress = 10
        let end_B = 10
        let allLength = 90
        let sliceLength = fileChunkList.length
        const sliceLengthMath = Math.round(allLength / sliceLength)
        for (let key in uploadUrlBo.uploadUrls) {
            let chunk = fileChunkList.find((chunk) => chunk.index === key)
            const requestHeader = uploadUrlBo.uploadUrls[key].requestHeader
            const requestURL = uploadUrlBo.uploadUrls[key].requestURL
            await putFile(chunk, requestHeader, requestURL, (evt) => {
                // console.log( Math.round(evt.loaded / evt.total * 100) + "%")
                const b = Math.round((evt.loaded) / evt.total * sliceLengthMath) + end_B
                if (onprogress) {
                    onprogress({
                        progress: b - 1,
                        msg: "正在上传"
                    })
                }
                if (evt.loaded === evt.total) {
                    progress += b
                    end_B = b
                }
            }, () => {
                if (onerror) {
                    onerror("上传失败")
                }
                if (onprogress) {
                    onprogress({
                        progress: 100,
                        msg: "上传失败"
                    })
                }
            })
        }
        if (onprogress) {
            onprogress({
                progress: 99,
                msg: "正在查询已上传分片"
            })
        }
        const uploadedPartsInfo = await getUploadedPartsInfo(token, multiUploadData.data.uploadFileId)
        if (uploadedPartsInfo.code === "SUCCESS") {
            if (onprogress) {
                onprogress({
                    progress: 99,
                    msg: "正在提交"
                })
            }
            const file = await commitMultiUploadFile(token, multiUploadData.data.uploadFileId)
            if (file.code === "SUCCESS") {
                console.log("上传成功")
                if (onprogress) {
                    onprogress({
                        progress: 100,
                        msg: "上传成功"
                    })
                }
            } else {
                if (onerror) {
                    onerror(file.msg)
                }
                if (onprogress) {
                    onprogress({
                        progress: 100,
                        msg: "上传失败"
                    })
                }
                console.log(uploadedPartsInfo)
            }
        } else {
            if (onprogress) {
                onprogress({
                    progress: 100,
                    msg: "上传失败"
                })
            }
            if (onerror) {
                onerror(uploadedPartsInfo.msg)
            }
            console.log("上传失败")
        }
    }
}